module.exports = "<p>{{text}}</p>\r\n"